import { useCallback, useEffect, useState } from "react";

const useDiff = ({startDate, endDate}) => {
  const [diffDays, setDiffDays] = useState(0);
  const getDays = useCallback(() => {
    const date1 = new Date(startDate);
    const date2 = new Date(endDate);
    const diffTime = Math.abs(date2 - date1);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    setDiffDays(diffDays);
  }, [ startDate, endDate]);
  
  useEffect(() => {
    getDays();
  }, [getDays, startDate,endDate]);

  return [diffDays];
};
export default useDiff;
